import { StrictMode } from "react"
import ReactDOM from "react-dom/client"
import { HelmetProvider } from "react-helmet-async"
import { BrowserRouter } from "react-router-dom"
import App from "./App"
import { CollapseDrawerProvider } from "./contexts/CollapseDrawerContext"
import { SettingsProvider } from "./contexts/SettingsContext"
import "./index.css"
import reportWebVitals from "./reportWebVitals"

const root = document.getElementById("root")

if (root !== null) {
  const reactRoot = ReactDOM.createRoot(root)
  reactRoot.render(
    <StrictMode>
      <HelmetProvider>
        <SettingsProvider>
          <CollapseDrawerProvider>
            <BrowserRouter future={{ v7_startTransition: true }}>
              <App />
            </BrowserRouter>
          </CollapseDrawerProvider>
        </SettingsProvider>
      </HelmetProvider>
    </StrictMode>
  )
}
reportWebVitals()
